<div class="menu-view-container">
  @if (isLoading) {
    <div class="loading">{{ 'menu_management.loading_menu' | translate }}</div>
  } @else if (error) {
    <div class="error">{{ error }}</div>
  } @else if (menu) {
    <div class="menu-header">
      <div class="menu-header-start">
        <button type="button" class="back-button" (click)="goBack()" aria-label="Back">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#12314F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="logo">
          <img src="assets/svg/logo.svg" alt="ScanMe">
        </div>
      </div>
      <div class="business-name">{{ menu.business_name || menu.menu_name }}</div>
    </div>

    <div class="menu-content">
      @if (menuItems && menuItems.length > 0) {
        <div class="menu-items-list-container">
          <div class="menu-items-list">
            @for (item of menuItems; track item.id) {
              <div class="menu-item-row">
                <div class="menu-item-thumbnail">
                  @if (item.image) {
                    <img [src]="getImageSrc(item.image)" [alt]="item.name" (error)="handleImageError($event)" class="menu-item-image">
                  } @else {
                    <div class="menu-item-placeholder">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 16L8.586 11.414C9.367 10.633 10.633 10.633 11.414 11.414L16 16M14 14L15.586 12.414C16.367 11.633 17.633 11.633 18.414 12.414L20 14M14 8H14.01M6 20H18C19.105 20 20 19.105 20 18V6C20 4.895 19.105 4 18 4H6C4.895 4 4 4.895 4 6V18C4 19.105 4.895 20 6 20Z" stroke="#6B6C77" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  }
                </div>
                <div class="menu-item-content">
                  <div class="menu-item-title">{{ item.name }}</div>
                  @if (item.description) {
                    <div class="menu-item-description">{{ item.description }}</div>
                  }
                </div>
                <div class="menu-item-value">
                  @if (item.hasQuantity) {
                    <div class="selected-quantity">{{ item.selectedQuantity || 1 }}</div>
                    <div class="primary-value">{{ item.quantity }} ֏</div>
                    <div class="secondary-value">{{ toUsd(item.quantity) | number:'1.1-1' }} $</div>
                  } @else {
                    <div class="primary-value">{{ item.price }} ֏</div>
                    <div class="secondary-value">{{ toUsd(item.price) | number:'1.1-1' }} $</div>
                  }
                </div>
                <div class="menu-item-control">
                  @if (item.hasQuantity) {
                    <div class="quantity-selector">
                      <button type="button" class="quantity-btn quantity-btn-plus" (click)="increaseQuantity(item.id)">
                        <span class="quantity-symbol" aria-hidden="true">+</span>
                      </button>
                      <button type="button" class="quantity-btn quantity-btn-minus" (click)="decreaseQuantity(item.id)" [disabled]="!item.selectedQuantity || item.selectedQuantity === 0">
                        <span class="quantity-symbol" aria-hidden="true">−</span>
                      </button>
                    </div>
                  } @else {
                    @if (allowsMultipleProducts) {
                      <div class="menu-item-checkbox" [class.selected]="isMenuItemSelected(item.id)" (click)="selectMenuItem(item.id)"></div>
                    } @else {
                      <div class="menu-item-radio" [class.selected]="isMenuItemSelected(item.id)" (click)="selectMenuItem(item.id)"></div>
                    }
                  }
                </div>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="menu-items-placeholder">
          <p>{{ 'menu_management.no_menu_items_available' | translate }}</p>
        </div>
      }
    </div>

    <div class="payment-method-footer">
      <div class="payment-method-total">
        <span class="label">{{ 'fee.total' | translate }}</span>
        <div class="values">
          <span class="usd">{{ totalUsd | number:'1.1-1' }} $</span>
          <span class="amd">{{ totalAmd }} ֏</span>
        </div>
      </div>
      <div class="payment-method-tabs">
        <button
          type="button"
          class="payment-method-btn"
          [class.active]="selectedPaymentMethod === 'apple'"
          [class.disabled]="hasNoSelection"
          [disabled]="hasNoSelection"
          (click)="setPaymentMethod('apple')"
        >
          Apple Pay
        </button>
        <button
          type="button"
          class="payment-method-btn"
          [class.active]="selectedPaymentMethod === 'other'"
          [class.disabled]="hasNoSelection"
          [disabled]="hasNoSelection"
          (click)="openOtherPaymentTemplate()"
        >
          {{ 'fee.other_payment' | translate }}
        </button>
      </div>
    </div>
  }
</div>
